import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PolicyTemplate } from "types/generated";

const PoliciesTemplatesTableDescriptionCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<PolicyTemplate>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={template.description} />
    </TableSimpleCell>
  );
};

export default PoliciesTemplatesTableDescriptionCell;
